// @flow
import { put, call, takeLatest } from "redux-saga/effects";
import {
  DELETE_HAZARD,
  DELETE_HAZARD_ERROR,
  DELETE_HAZARD_SUCCESS,
} from "../../constants";
import axios from "../../../../services/api";
import { push } from "connected-react-router";
import { success } from "../../../../main";

function deleteReq(data) {
  return axios.delete("/hazards/", { data: { id: data.id } });
}

function* deleteHazard(data) {
  try {
    const response = yield call(deleteReq, data);
    yield put({
      type: DELETE_HAZARD_SUCCESS,
      data: response,
    });

    yield call(success, `Hazard Deleted Succesfully`);
  } catch (error) {
    console.log({ error });
    yield put({
      type: DELETE_HAZARD_ERROR,
      data: error,
    });
  }
}

export default function* deleteHazardSaga() {
  yield takeLatest(DELETE_HAZARD, deleteHazard);
}
